import { filtrosLaterais } from "app/_models/filtros-laterais";
import { Cotacao } from "app/_models/cotacao";

export class MinhasCotacoes {
    constructor(public FiltrosLateraisAtivos: filtrosLaterais, 
                public Cotacoes : Cotacao[] = []){        
    }
}